import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { PageService } from '../../services/page.service';
import { SmartLabelService } from '../smart-label/smart-label.service';
@Component({
  selector: 'app-content-control',
  templateUrl: './content-control.component.html',
  styleUrls: ['./content-control.component.scss']
})
export class ContentControlComponent implements OnInit, AfterViewInit {
  @Input() contentControls: Array<any> = [];
  diData;
  customGetAPIData;
  data; //combo of the above;

  constructor(
    private smartlabelService: SmartLabelService,
    private pageService: PageService) { }

  ngOnInit() {
    this.diData = this.pageService.diData;
    this.customGetAPIData = this.pageService.customGetAPIData;
    this.data = {
      "entityInformation": this.pageService.diData,
      "customGetAPI": this.pageService.customGetAPIData
    }
  }

  ngAfterViewInit() {

  }

  /**
   * onOptionChange - used to set smartlabelEvents object after option change is emitted.
   * @param event - {type: , payload: {}} format.
   * @task - QLIKTAG-3597
   * @author - SwapnilP
   */
  onOptionChange(event: { type: string, payload: { [key: string]: any } }) {
    if (event.type === 'smartlabel-selector') {
      this.smartlabelService.smartLabelEvents$.next(event);
    }
  }
}
